import Vue from "vue";
import jquery from "jquery";

// Vendor CSS must be imported before App so resume.css overrides it,
// matching the production build where chunk-vendors.css is loaded first.
import "bootstrap/dist/css/bootstrap.css";
import "devicons/css/devicons.css";
import "font-awesome/css/font-awesome.css";

import App from "./App";

require("bootstrap");
require("jquery.easing");

Vue.prototype.jquery = jquery;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
});
